module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "refer.276ca6c6.png";